import { GetStaticPaths, GetStaticProps } from 'next';
import React, { useEffect } from 'react';
import Branchpage from '../../components/BranchPage';
import ErrorComponent from '../../components/ErrorComponent';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import fetchUtil from '../../utils/fetchUtil';
import { CACHE_REVALIDATE, commonJotformScript } from '../../utils/constants';


const Brnchpage: React.FC = (props: any) => {
  if (!props.branchData || props.branchData.length === 0) {
    return <ErrorComponent />
  }
  const { meta } = props.branchData[0]
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6c48f0');
    customStyle.setProperty('--navbar-menu-color', '#ffff')
  }, [])

  const updatedMeta = meta?.jotforms?.length === 0
    ? { ...meta, jotforms: commonJotformScript }
    : { ...meta }

  return (
    <>
      {updatedMeta && <MetaTagsComp {...updatedMeta} />}
      <Branchpage {...props} />
    </>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  return { 
    paths: [], 
    fallback: 'blocking'
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const branchData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/offices?slug=${context.params?.slug}`, 'GET', {}, '', false)
  return {
    props: {
      branchData,
    },
    revalidate: CACHE_REVALIDATE
  };
}

export default Brnchpage;